import type { ComponentPropsWithRef } from 'react'

const BASE =
  'w-full rounded-control border border-line bg-surface px-3 py-2 text-sm text-ink placeholder:text-muted/70 outline-none transition-colors focus:border-brand-400'

export function Input({ className = '', ...rest }: ComponentPropsWithRef<'input'>) {
  return <input {...rest} className={`${BASE} ${className}`} />
}

export function Textarea({ className = '', ...rest }: ComponentPropsWithRef<'textarea'>) {
  return <textarea {...rest} className={`${BASE} resize-none ${className}`} />
}
